<template>
  <div>
    <el-carousel height="5.2rem"
      :autoplay="true"
      :interval="5000">
      <el-carousel-item>
        <img src="../assets/images/banner/home/3.jpg"
          width="100%"
          height="100%"
          @click="pubClick2('site',null,3)">
      </el-carousel-item>
      <el-carousel-item style="cursor: pointer;">
        <img src="../assets/images/banner/home/4.jpg"
          width="100%"
          height="100%"
          @click="pubClick2('site',null,3)">
      </el-carousel-item>
      <el-carousel-item style="cursor: pointer;">
        <img src="../assets/images/banner/home/2.jpg"
          width="100%"
          height="100%"
          @click="pubClick2('schemeSafety',null,3)">
      </el-carousel-item>
      <el-carousel-item style="cursor: pointer;">
        <img src="../assets/images/banner/home/1.jpg"
          width="100%"
          height="100%"
          @click="pubClick2('schemeCartoon',null,3)">
      </el-carousel-item>
      <el-carousel-item style="cursor: pointer;">
        <img src="../assets/images/banner/home/5.jpg"
          width="100%"
          height="100%"
          @click="pubClick2('live',null,3)">
      </el-carousel-item>
      <el-carousel-item style="cursor: pointer;">
        <img src="../assets/images/banner/home/6.jpg"
          width="100%"
          height="100%"
          @click="pubClick2('schemeShowRoom',null,3)">
      </el-carousel-item>
    </el-carousel>
    <div class="box">
      <div @click="pubClick3('productSite',2)">
        <img src="../assets/images/home/gd.png">
        <p>智慧工地</p>
      </div>
      <div @click="pubClick2('productSafetyDetail',8,2)">
        <img src="../assets/images/home/vr.png">
        <p>VR安全体验馆</p>
      </div>
      <div @click="pubClick2('schemeSafety',null,3)">
        <img src="../assets/images/home/aq.png">
        <p>智慧安全解决方案</p>
      </div>
      <div @click="pubClick2('productSafety',1,2)">
        <img src="../assets/images/home/zn.png">
        <p>智慧安全产品开发</p>
      </div>
      <div @click="pubClick2('schemeShowRoom',null,2)">
        <img src="../assets/images/home/xw.png">
        <p>项目展厅展馆</p>
      </div>
      <div @click="pubClick3('productCartoon',2)">
        <img src="../assets/images/home/sp.png">
        <p>工程动画</p>
      </div>
    </div>
    <div class="box2">
      <div class="tit">智慧工地</div>
      <div class="tit2">基于AIoT的智慧工地管理系统</div>
      <div class="bor"></div>
    </div>
    <div class="box3">
      <div class="bu"
        @click="pubClick2('site',null,3)">
        <img src="../assets/images/home/gd1.jpg"
          width="100%"
          height="100%">
        <div class="dow">
          <div>京东方</div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="bu"
        @click="pubClick2('site',null,3)">
        <img src="../assets/images/home/gd2.jpg"
          width="100%"
          height="100%">
        <div class="dow">
          <div>碧桂园</div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="bu"
        @click="pubClick2('site',null,3)">
        <img src="../assets/images/home/gd3.jpg"
          width="100%"
          height="100%">
        <div class="dow">
          <div>东江之星</div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="bu mar"
        @click="pubClick2('site',null,3)">
        <img src="../assets/images/home/gd4.jpg"
          width="100%"
          height="100%">
        <div class="dow">
          <div>金地中心</div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <!--        <div class="box4">-->
    <!--            <div class="tit" style="padding-top:.5rem;color:#fff">产品服务</div>-->
    <!--            <div class="tit2">持续提升客户数字技术体验</div>-->
    <!--            <div class="bor"></div>-->
    <!--            <div class="min">-->
    <!--                <div class="bo" @click="pubClick2('productSafetyDetail',8,2)">-->
    <!--                    <img src="../assets/images/home/p5.jpg" class="bg">-->
    <!--                    <div class="fo">-->
    <!--                        <img src="../assets/images/home/vr2.png">-->
    <!--                        <p>VR安全体验馆</p>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                <div class="bo" @click="pubClick2('productSite',null,2)">-->
    <!--                    <img src="../assets/images/home/p1.jpg" class="bg">-->
    <!--                    <div class="fo">-->
    <!--                        <img src="../assets/images/home/rj.png">-->
    <!--                        <p>软硬件开发</p>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                <div class="bo" @click="pubClick('cartoonDetail','carCode',1,2)">-->
    <!--                    <img src="../assets/images/home/p2.jpg" class="bg">-->
    <!--                    <div class="fo">-->
    <!--                        <img src="../assets/images/home/ps.png">-->
    <!--                        <p>宣传片拍摄</p>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                <div class="bo" @click="pubClick('cartoonDetail','carCode',26,2)">-->
    <!--                    <img src="../assets/images/home/p3.jpg" class="bg">-->
    <!--                    <div class="fo">-->
    <!--                        <img src="../assets/images/home/hp.png">-->
    <!--                        <p>摄像航拍</p>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                <div class="bo" @click="pubClick2('schemeShowRoom',null,3)">-->
    <!--                    <img src="../assets/images/home/p4.jpg" class="bg">-->
    <!--                    <div class="fo">-->
    <!--                        <img src="../assets/images/home/zt.png">-->
    <!--                        <p>智慧展厅</p>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <div class="box2">
      <div class="tit">经典案例</div>
      <div class="tit2">为客户提供更具竞争力的综合解决方案</div>
      <div class="bor"></div>
    </div>
    <div class="box5">
      <div class="dow"
        @click="applyClick(1,$event)">工程动画</div>
      <div @click="applyClick(2,$event)">智慧安全</div>
      <div @click="applyClick(3,$event)">智慧工地</div>
    </div>
    <div class="box6">
      <div class="mu2"
        v-for="(item,index) in applyList"
        :key="item.id"
        :class="index===0? 'mar':''"
        @click="pubClick(item.url,item.code,item.id,item.idx)">
        <img :src="item.img"
          width="100%"
          height="100%">
        <div class="dow">
          <div>{{ item.title }}</div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="tit">新闻中心</div>
      <div class="tit2">最新动态</div>
      <div class="bor"></div>
    </div>
    <div class="box8">
      <div class="lef"
        style="margin-right:.5rem; cursor: pointer"
        @click="goNews(0)">
        <img :src="newsList[0].homeImage"
          width="100%"
          height="50%">
        <div class="bot">
          <div style="margin: .05rem .2rem 0 .3rem;width: 1rem">
            <p class="p1">{{ newsList[0].day }}</p>
            <p class="p2"></p>
            <p class="p3"
              style="width: 58px">{{ newsList[0].year }}-{{ newsList[0].month }}</p>
          </div>
          <p class="ri"
            style="margin-right: .2rem; line-height: .4rem">{{ newsList[0].titleNormal }}</p>
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="lef rit">
        <div class="bot"
          v-for="(item,index) in newsList"
          v-if="index < 4 && index > 0"
          :key="index"
          @click="goNews(index)">
          <div style="display: flex">
            <div class="le">
              <p class="p1">{{ item.day }}</p>
              <p class="p2"></p>
              <p class="p3">{{ item.year }}-{{ item.month }}</p>
            </div>
            <p class="ri">{{ item.titleSmall }}</p>
          </div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="news_more"
      @click="goList">查看更多 <i class="el-icon-arrow-right"></i></div>
    <div class="box9">
      <div class="man">
        <div>
          <p class="p4">18</p>
          <p class="p5">18年的服务经验</p>
        </div>
        <div>
          <p class="p4">30+</p>
          <p class="p5">30+政府单位的认可</p>
        </div>
        <div>
          <p class="p4">300</p>
          <p class="p5">300人专业团队</p>
        </div>
        <div>
          <p class="p4">900+</p>
          <p class="p5">900+建筑企业的选择</p>
        </div>
        <div style="border-right: none">
          <p class="p4">2000+</p>
          <p class="p5">2000+行业经验累积</p>
        </div>
      </div>
    </div>
    <div class="box2">
      <div class="tit">我们的客户</div>
      <div class="tit2">专业化的服务,为我们赢得了众多客户的信任</div>
      <div class="bor"></div>
    </div>
    <div class="box10">
      <img src="../assets/images/home/kh.jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data () {
    return {
      activeIndex: '1',
      boxList: [
        { name: '智慧工地', img: require('../assets/images/home/gd.png'), url: 'productSite' }
      ],
      applyList: [
        {
          id: 1,
          title: '景成大厦项目施工动画演示',
          img: require('../assets/images/home/d1.jpg'),
          url: 'carDetail',
          code: 'carCode2',
          idx: 3
        },
        {
          id: 4,
          title: '深圳机场卫星厅及其配套工程建造演示',
          img: require('../assets/images/home/d2.jpg'),
          url: 'carDetail',
          code: 'carCode2',
          idx: 3
        },
      ],
      applycar: [
        {
          id: 1,
          title: '景成大厦项目施工动画演示',
          img: require('../assets/images/home/d1.jpg'),
          url: 'carDetail',
          code: 'carCode2',
          idx: 3
        },
        {
          id: 4,
          title: '深圳机场卫星厅及其配套工程建造演示',
          img: require('../assets/images/home/d2.jpg'),
          url: 'carDetail',
          code: 'carCode2',
          idx: 3
        },
      ],
      applysafety: [
        {
          id: 1,
          title: 'VR安全培训体验中心',
          img: require('../assets/images/home/a1.jpg'),
          url: 'applySafety',
          code: 'safetyCode2',
          idx: 3
        },
        {
          id: 2,
          title: '安全教育一体机',
          img: require('../assets/images/home/a2.jpg'),
          url: 'applySafety',
          code: 'safetyCode2',
          idx: 3
        },
      ],
      applysite: [
        {
          id: 2,
          title: '长沙京武浪琴山三期',
          img: require('../assets/images/home/g1.jpg'),
          url: 'applyDetail',
          code: 'applyCode',
          idx: 4
        },
        {
          id: 10,
          title: '深圳恒大中心',
          img: require('../assets/images/home/g2.jpg'),
          url: 'applyDetail',
          code: 'applyCode',
          idx: 4
        },
      ],
      newsList: this.$newsList
      /* newsList: [
          {month: '16', year: '2021-04', text: '建筑港与九象数字在深圳签署战略合作协议', page: 54},
          {month: '23', year: '2021-03', text: '2021年，九象这样干：定目标，追过程，拿结果', page: 53},
          {month: '23', year: '2021-03', text: '九象铁军文化：九象铁军，王者之师，勇往直前，势不可挡', page: 52},
      ] */
    }
  },
  methods: {
    goNews (index) {
      this.$router.push({
        path: 'new',
        query: {
          page: index
        }
      });
      document.documentElement.scrollTop = 0;
    },
    goList () {
      this.$router.push('news-list');
      document.documentElement.scrollTop = 0;
    },
    pubClick (url, name, code, idx) {
      this.$router.push(url);
      sessionStorage.setItem(name, code);
      sessionStorage.setItem('idx', idx);
    },
    pubClick2 (url, evn, idx) {
      this.$router.push({
        path: url,
        query: {
          index: evn
        }
      });
      document.documentElement.scrollTop = 0;
      sessionStorage.setItem('idx', idx);
    },
    pubClick3 (url, idx) {
      this.$router.push(url);
      document.documentElement.scrollTop = 0;
      sessionStorage.setItem('idx', idx);
    },
    applyClick (evn, e) {
      e.target.classList.add('dow');
      switch (evn) {
        case 1:
          this.applyList = this.applycar;
          e.target.nextElementSibling.classList.remove('dow');
          e.target.nextElementSibling.nextElementSibling.classList.remove('dow');
          break;
        case 2:
          this.applyList = this.applysafety;
          e.target.previousElementSibling.classList.remove('dow');
          e.target.nextElementSibling.classList.remove('dow');
          break;
        default:
          this.applyList = this.applysite;
          e.target.previousElementSibling.classList.remove('dow');
          e.target.previousElementSibling.previousElementSibling.classList.remove('dow');
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.news_more {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.18rem;
  margin: 0.3rem auto 0.3rem;
  cursor: pointer;

  &:hover {
    color: #e70f20;

    i {
      color: #e70f20;
    }
  }

  i {
    font-size: 0.22rem;
    color: #b5b5b5;
  }
}

.box {
  width: 12rem;
  margin: 0 auto;
  height: 2.4rem;
  font-size: 0.2rem;
  display: flex;

  div {
    width: 2rem;
    height: 2.4rem;
    text-align: center;
    cursor: pointer;

    img {
      width: 0.83rem;
      height: 0.83rem;
      margin: 0.55rem 0 0.3rem 0;
    }
  }

  div:hover {
    background: #f9f9f9;
  }

  .dow {
    background: #f9f9f9;
  }
}

.box2,
.box4 {
  text-align: center;
  margin-top: 0.46rem;

  .tit {
    font-size: 0.36rem;
  }

  .tit2 {
    font-size: 0.22rem;
    color: #939393;
    line-height: 0.57rem;
  }

  .bor {
    width: 1.3rem;
    height: 2px;
    background: #e70f20;
    margin: 0 auto;
    margin-top: 0.12rem;
  }
}

.box3 {
  width: 12rem;
  margin: 0.53rem auto;
  display: flex;

  div.bu {
    width: 2.94rem;
    height: 3.7rem;
    margin-right: 0.1rem;
    position: relative;
    cursor: pointer;

    .dow {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      font-size: 0.2rem;
      color: #fff;
      text-align: center;
      display: none;

      div {
        line-height: 0.63rem;
        margin-top: 1.5rem;
      }
    }
  }

  div.bu:hover {
    div.dow {
      display: block;
    }
  }

  .mar {
    margin-right: 0;
  }
}

.box4 {
  height: 6.5rem;
  width: 100%;
  background: url("../assets/images/home/bg1.jpg");
  background-size: 100% 100%;
  margin-top: 0.75rem;

  .min {
    width: 12rem;
    margin: 0.5rem auto;
    display: flex;

    div.bo {
      position: relative;
      width: 2.32rem;
      height: 3.7rem;
      margin-right: 0.12rem;
      cursor: pointer;

      p {
        font-size: 0.2rem;
        color: #fff;
        line-height: 0.45rem;
      }

      img.bg,
      div.fo {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      div.fo:hover {
        background: rgba(231, 15, 32, 0.6);
      }

      div.fo {
        img {
          margin-top: 1.4rem;
        }
      }
    }
  }
}

.box5 {
  text-align: center;
  margin: 0.4rem 0 0.3rem;

  div {
    width: 1.63rem;
    height: 0.4rem;
    line-height: 0.4rem;
    font-size: 0.18rem;
    background: #f7f7f7;
    display: inline-block;
    margin: 0 0.02rem;
    cursor: pointer;
  }

  .dow {
    border: 1px solid #eee;
    background: none;
    color: #e70f20;
  }
}

i {
  color: #fff;
  font-size: 0.36rem;
}

.box6 {
  width: 12rem;
  margin: 0 auto;
  display: flex;

  .mu2 {
    width: 5.96rem;
    height: 3.7rem;
    position: relative;
    cursor: pointer;

    .dow {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      font-size: 0.2rem;
      color: #fff;
      text-align: center;
      display: none;

      div {
        line-height: 0.63rem;
        margin-top: 1.5rem;
      }
    }
  }

  div.mu2:hover {
    div.dow {
      display: block;
    }
  }

  .mar {
    margin-right: 0.1rem;
  }
}

.box8 {
  width: 9.95rem;
  margin: 0.5rem auto 0.1rem;
  display: flex;

  .lef {
    width: 4.7rem;
    height: 4.9rem;
    background: #f5f5f5;
    position: relative;

    .bot {
      margin-top: 0.4rem;
      position: relative;
      display: flex;
      cursor: pointer;

      .p1 {
        font-size: 0.3rem;
      }

      .p2 {
        width: 0.3rem;
        height: 1px;
        background: #e70f20;
        margin-top: 0.03rem;
      }

      .p3 {
        font-size: 0.14rem;
        color: #939393;
        line-height: 0.4rem;
      }

      .ri {
        font-size: 0.24rem;
        line-height: 0.35rem;
      }
    }

    i {
      position: absolute;
      bottom: 0.08rem;
      right: 0.07rem;
      font-size: 0.26rem;
      color: #b5b5b5;
    }
  }

  .rit {
    background: none;

    .bot {
      border: 1px solid #eee;
      margin: 0 0 0.35rem;
      height: 1.4rem;
      padding-top: 0.25rem;

      .le {
        padding: 0.15rem 0 0 0.42rem;
        width: 1.24rem;
      }

      .ri {
        width: 3.44rem;
        border-left: 1px solid #eaeaea;
        height: 0.88rem;
        padding: 0.08rem 0.35rem 0 0.3rem;
        font-size: 0.19rem;
      }
    }
  }
}

.box9 {
  height: 3rem;
  background: url("../assets/images/home/bot.jpg");
  background-size: 100% 100%;

  .man {
    width: 12.8rem;
    margin: 0 auto;
    display: flex;

    div {
      width: 2.55rem;
      height: 1rem;
      border-right: 1px solid #e5e5e5;
      text-align: center;
      margin-top: 1rem;

      .p4 {
        font-size: 0.6rem;
        color: #e70f20;
        line-height: 0.56rem;
      }

      .p5 {
        font-size: 0.18rem;
        line-height: 0.55rem;
      }
    }
  }
}

.box10 {
  margin: 0.5rem auto 0;
  text-align: center;

  img {
    width: 12rem;
    height: 1.82rem;
  }
}
</style>
